/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { Toaster } from "react-hot-toast";
import {isAndroid} from '@walletconnect/browser-utils';
import { useTheme } from "../providers/theme";
import { LoginModalVW } from "../widgets/LoginModalVW";
import { StateOSDModalVW } from "../widgets/StateOSDModalVW";
import { StateOPTModalVW } from "../widgets/StateOPTModalVW";
import {ContactFormModalVW} from "../widgets/ContactFormModalVW";
import { VApplication } from '../application';
import { WalletconnectModule } from "../modules/WalletConnect";
import { StorageModule } from "@vlinder-web/storage-module-react";

const getWalletModule = () => {
    const vapp = VApplication.getInstance();
    const walletconnentModule = vapp.getSync(
        "services.WalletconnectModule"
    ) as WalletconnectModule;
    return walletconnentModule;
};

export const Accessories = () => {
    const theme = useTheme();
    if (sessionStorage.getItem('reloaded') != null) {
        console.log('page was reloaded');
    } else {
        console.log('page was not reloaded');
    }
    sessionStorage.setItem('reloaded', 'yes');

    window.addEventListener('beforeunload', function (e) {
        if (!isAndroid()) {
            const module = getWalletModule();
            module.killSession();
            // e.preventDefault();
            // e.returnValue = '';
        }
    });
    const storageService = StorageModule.getInstance();
    const DEFAULT_APP_CONFIG = storageService.get("appConfig", "session");
    let headers = {
        "store-id": DEFAULT_APP_CONFIG?.organization?.storeId,
    };

    return (
        <>
            <StateOSDModalVW />
            <StateOPTModalVW />
            <ContactFormModalVW />
            <LoginModalVW
                apiURL={DEFAULT_APP_CONFIG?.servers?.rest?.loginServer?.baseURL}
                termsURL ={DEFAULT_APP_CONFIG?.organization?.termsURL}
                headers={headers}
            />
            <Toaster
                toastOptions={{
                    className: "",
                    duration: 8000,
                    style: {
                        borderLeft: `4px solid ${theme?.colors?.primary}`,
                        padding: "16px",
                        color: theme?.colors?.black,
                        fontSize: 15,
                        fontWeight: "bolder",
                    },

                    success: {
                        style: {
                            borderColor: theme?.colors?.toastSuccess,
                        },
                    },
                    error: {
                        style: {
                            borderColor: theme?.colors?.toastError,
                        },
                    },
                }}

            />
        </>
    );
};
